import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { VoiceConfigModel } from 'src/app/models/voice-config.model';
import { DeviceModel } from 'src/app/models/device.model';
import { UserModel } from 'src/app/models/user.model';
import { ApiService, createFailureToDeleteMsg } from 'src/app/services/api.service';

@Component({
  selector: 'app-delete-vconfig',
  templateUrl: './delete-vconfig.component.html',
  styleUrls: ['./delete-vconfig.component.scss']
})
export class VConfigDeleteComponent implements OnChanges {
  @BlockUI() blockUI: NgBlockUI | undefined;
  @Input() visible = false;
  @Input() vConfigs: any[] = [];
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() visibleChange: EventEmitter<any> = new EventEmitter();

  isLoading = false;
  isVam = false;
  isReviewer = false;
  isOps = false;

  currentUser?: UserModel;

  canDelete = true;
  attachedDevicesByProfile: {
    profileName: string;
    profileOrg: string;
    devices: DeviceModel[]
  }[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private location: Location,
    private messageService: MessageService
  ) {
    const userStr = localStorage.getItem('currentUser');
    if (userStr) {
      this.currentUser = JSON.parse(userStr);
      this.isVam = this.currentUser?.organization.type === 'VAM';
      this.isReviewer = this.currentUser?.role === 'Reviewer';
      this.isOps = this.currentUser?.role === 'Ops';
    }
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes['visible'] && this.visible) {
      await this.checkAttachedDevices();
    }
  }

  private async checkAttachedDevices(): Promise<void> {
    try {
      this.isLoading = true;
      this.attachedDevicesByProfile = [];

      for (const vConfig of this.vConfigs) {
        if (!vConfig.groupId) {
          continue;
        }

        const devices = await this.api.get<DeviceModel[]>(
          `/devices/voice-config/group/${vConfig.groupId}`
        );

        if (devices?.length) {
          this.attachedDevicesByProfile.push({
            profileName: vConfig.name,
            profileOrg: vConfig.org?.name,
            devices
          });
        }
      }

      this.canDelete = this.attachedDevicesByProfile.length === 0;
    } finally {
      this.isLoading = false;
    }
  }

  async delete() {
    if (!this.canDelete) {
      return;
    }

    try {
      this.blockUI?.start();

      const payload = this.vConfigs.map(vConfig => vConfig.id);

      console.log(`delete payload is ${payload}`);

      const response = await this.api.request('DELETE', `/voice-configs`, {
        body: { ids: payload }
      });

      console.log(`${JSON.stringify(response)}`);

      this.onClose.emit();
      this.visible = false;
      this.visibleChange.emit(false);
    } catch (err: any) {
      console.log(`${JSON.stringify(err)}`);
      const errors = createFailureToDeleteMsg(err, this.vConfigs, 'voice profile');
      this.messageService.addAll(errors);
    } finally {
      this.blockUI?.stop();
    }
  }

  closeDialog(): void {
    this.attachedDevicesByProfile = [];
    this.canDelete = true;
    this.isLoading = false;
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onCloseDialog(): void {
    this.attachedDevicesByProfile = [];
    this.canDelete = true;
    this.isLoading = false;
  }
}